import { API_endpoints } from "../config";

export const deleteBooking = async (id: any) => {
    try {
        const response = await fetch(API_endpoints.deleteBooking, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({id}),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim bearbeitung von Booking.");
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Fehler beim bearbeitung von Booking:", error);
        throw error;
    }
};
